export const numbersOnly = (input?: string) => {
  if (!input) return ''

  return input.replace(/\D+/g, '')
}

export const getClosestValue = (target: number, haystack: Array<number> = []) =>
  haystack.sort((stalk1, stalk2) => Math.abs(target - stalk1) - Math.abs(target - stalk2))[0]!
